/* Tab prodotto */
document.addEventListener('DOMContentLoaded', function() {
            var tabBtns = document.querySelectorAll('.tab-prodotto-nav .tab-btn');
            var tabContents = document.querySelectorAll('.tab-prodotto-tabs .tab-prodotto-content');
            tabBtns.forEach(function(btn) {
                btn.addEventListener('click', function() {
                    var tab = this.getAttribute('data-tab');
                    tabBtns.forEach(function(b){ b.classList.remove('active'); });
                    tabContents.forEach(function(tc){ tc.classList.remove('active'); });
                    this.classList.add('active');
                    var el = document.querySelector('.tab-prodotto-tabs .tab-prodotto-content.'+tab);
                    if(el) el.classList.add('active');
                });
            });
        });



// WEBPACK FOOTER //
// ./js/widget/tab-prodotto.js